import React, { useContext, useState } from 'react'
import Select from '../components/Select'
import { USER_CONTEXT } from '../context/ContextProvider'

const useCreateForm = () => {
  let { data } = useContext(USER_CONTEXT)
  let [selected, setSelected] = useState(0)
  let [selectedGroup, setSelectedGroup] = useState(0)
  let status = ['Backlog', 'To do', 'In Progress', 'Completed']

  let createForm = (defaultValue = {}) => {
    return [
      [
        {
          label: 'Title',
          input: {
            element: 'input',
            props: {
              defaultValue: defaultValue.title || '',
              id: 'title',
              type: 'text',
              placeholder: 'Github Production Build',
            },
          },
        },
        {
          label: 'Tagline',
          input: {
            element: 'input',
            props: {
              defaultValue: defaultValue.tagline || '',
              id: 'tagline',
              type: 'text',
              placeholder: 'Create a production buld for new github branch',
            },
          },
        },
        {
          label: 'Tags',
          input: {
            element: 'input',
            props: {
              defaultValue: defaultValue.tags || '',
              id: 'tags',
              type: 'text',
              placeholder: 'Research Company Project',
            },
          },
        },
        {
          label: 'Status',
          input: {
            element: Select,
            props: {
              defaultValue: defaultValue.status || '',
              id: 'status',
              values: status,
              selected,
              setSelected,
            },
          },
        },
        {
          label: 'Group',
          input: {
            element: Select,
            props: {
              defaultValue: defaultValue.group || '',
              id: 'group',
              values: data.groups,
              selected: selectedGroup,
              setSelected: setSelectedGroup,
            },
          },
        },
      ],
      selected,
      selectedGroup,
    ]
  }

  return createForm
}

export default useCreateForm
